module.exports = __webpack_public_path__ + "static/media/Wearpeachi_1_Butter Bae Cami Bra in Rosewood.8aed3766.jpeg";